import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PatientProgramStatusForm } from "../../../components/program-status/PatientProgramStatusForm";
import { workflowService } from "@/services/features/WorkflowService";
import { useAuth } from "@/contexts/AuthContext";
import { useErrorHandler } from "@/hooks/useErrorHandler";

const AddPatientProgramStatus = () => {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const { handleError, handleSuccess } = useErrorHandler();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: any) => {
    if (!user?.id || !token) {
      handleError(new Error("Missing authentication data"));
      return;
    }

    setIsSubmitting(true);
    try {
      await workflowService.createProgramStatus(user.id, data, token);
      handleSuccess("Program status created successfully");
      navigate("/admin/program-type", { state: { activeTab: "patient-program-status" } });
    } catch (error) {
      handleError(error, "Failed to create program status");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/admin/program-type", { state: { activeTab: "patient-program-status" } });
  };

  return (
    <PatientProgramStatusForm
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isEdit={false}
      isSubmitting={isSubmitting}
    />
  );
};

export default AddPatientProgramStatus;